var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"r8YAsSXQm3S8X9A_XjYXl"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["emak-frontend@webranking-srl"]={id:"r8YAsSXQm3S8X9A_XjYXl"};
      